import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

export const validateUniSlugGuard = (route: ActivatedRouteSnapshot) => {
	const router = inject(Router);

	if (!route.queryParams['uni']) {
		router.navigateByUrl('/404');

		return false;
	}

	return true;
};
